// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__204RI","content":"styles_content__26JcS"};